<template>
  <Fragment>
    <NavBanner />
    <nav class="navigation-wrapper">
      <TopNavigation />
      <BottomNavigation />
    </nav>
  </Fragment>
</template>

<script>
import TopNavigation from "./navigation-options/topNavigation.vue";
import BottomNavigation from "./navigation-options/bottomNavigation.vue";
import NavBanner from "./navigation-options/navBanner.vue";
import { Fragment } from "vue-frag";

export default {
  components: {
    TopNavigation,
    BottomNavigation,
    NavBanner,
    Fragment,
  },
};
</script>
